module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Streaming_Devices.78826244.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Streaming_Devices.svg
// module id = 3544
// module chunks = 0